/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) RMA (bulk deletion of provisioned devices) Icon component.
 */
export const RmaIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2412_25015)">
        <path d="M7.33999 6.41001L0.859985 12.9L7.34999 19.38L13.84 12.9L7.33999 6.41001ZM3.68999 12.9L7.34999 9.24001L11 12.9L7.33999 16.56L3.68999 12.9ZM19.36 6.64001C17.61 4.88001 15.3 4.00001 13 4.00001V0.76001L8.75999 5.00001L13 9.24001V6.00001C14.79 6.00001 16.58 6.68001 17.95 8.05001C20.68 10.78 20.68 15.22 17.95 17.95C16.58 19.32 14.79 20 13 20C12.03 20 11.06 19.79 10.16 19.39L8.66999 20.88C10.02 21.62 11.51 22 13 22C15.3 22 17.61 21.12 19.36 19.36C22.88 15.85 22.88 10.15 19.36 6.64001Z" fill={iconColor}/>
      </g>
      <defs>
        <clipPath id="clip0_2412_25015">
          <rect width="24" height="24" fill={iconColor}/>
        </clipPath>
      </defs>
    </svg>
  );
};
